import Vue from 'vue';

// 暂时用作数值默认值
Vue.directive('num-blur-default', {
  bind: function(el, binding, vnode) {
    // vnode.componentInstance.$on('blur', function(e) {});
    el.addEventListener(
      'blur',
      e => {
        const iptEl = el.children[0].children[0];
        if (!iptEl.value) {
          const def = binding.value;
          vnode.data.model.callback(def);
          iptEl.dispatchEvent(new Event('input'));
        }
      },
      true
    );
  },
});
